Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Возвращает true, если значение равно null или undefined
 */
function isNil(value) {
    return value == null;
}
/**
 * Выбор значения между min max границами
 */
function clamp(value, min, max) {
    var clampedValue = Math.min(Number(max), Math.max(Number(min), Number(value)));
    return (value instanceof Date ? new Date(clampedValue) : clampedValue);
}
function noop() { }
var fnUtils = {
    clamp: clamp,
    noop: noop,
    isNil: isNil,
};

exports.fnUtils = fnUtils;
